import type { MantineSize } from '@mantine/core';

/**
 * Returns the pixel size for a Tabler icon placed inside an ActionIcon.
 *
 * **Design rule:** icon is always one Mantine size step smaller than the
 * ActionIcon that contains it (e.g. ActionIcon md → icon sm = 16px).
 *
 * **When to use:** any time you render a Tabler icon inside an ActionIcon and
 * the ActionIcon accepts a dynamic `size` prop.
 *
 * **How to use:**
 * ```tsx
 * <ActionIcon size={size}>
 *   <IconCopy size={deriveSizeIcon(size)} />
 * </ActionIcon>
 * ```
 *
 * At `xs` the icon stays at `xs` (no smaller step available).
 */
export const deriveSizeIcon = (size: MantineSize): number => {
  const order: MantineSize[] = ['xs', 'sm', 'md', 'lg', 'xl'];
  const px: Record<MantineSize, number> = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
  };
  return px[order[Math.max(0, order.indexOf(size) - 1)]];
};
